import { render, staticRenderFns } from "./MassiveProductDialog.vue?vue&type=template&id=73515fdc&lang=pug&"
import script from "./MassiveProductDialog.vue?vue&type=script&lang=js&"
export * from "./MassiveProductDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports